// Mandate text for recurring donations. Blackbaud renders it under its own
// "Frequency:" label and stores it on the payment method, so it must be a
// cadence phrase and must match the schedule we actually create.
//
// Required for recurring direct debit (error 20009); harmless for cards,
// which is why it is set for every recurring transaction.
const INTERVALS = {
  monthly: date => date.setMonth(date.getMonth() + 1),
  quarterly: date => date.setMonth(date.getMonth() + 3),
  annual: date => date.setFullYear(date.getFullYear() + 1),
}

export const firstInstallmentDate = (subscription, from = new Date()) => {
  const advance = INTERVALS[subscription]
  if (!advance) return null

  const date = new Date(from.getTime())
  advance(date)
  // Clamp month-end overflow (Jan 31 -> Feb 28, not Mar 3), as Rails does.
  if (date.getDate() !== from.getDate()) date.setDate(0)
  return date
}

const recurrenceDescription = ({ i18n, subscription, from }) => {
  const date = firstInstallmentDate(subscription, from)
  if (!date) return ''

  return i18n.t(`blackbaud.recurrence_description.${subscription}`, {
    date: date.toLocaleDateString(i18n.locale || 'en', {
      year: 'numeric', month: 'numeric', day: 'numeric',
    }),
  })
}

export default recurrenceDescription
